import React from "react";
import bannerImage from "../../assets/image/stella/main-banner-bg.jpg";
import { HashLink } from 'react-router-hash-link';

function Hero() {
    return (
        <section
            style={{
                backgroundImage: `linear-gradient(180deg,#00000085,#141414), url(${bannerImage})`
            }}
            id="inicio"
            className="pt-[120px] md:pt-[300px] pb-5 md:pb-[112px] text-center bg-dark bg-no-repeat bg-center bg-cover">
            <div
                className="p-12 max-w-[840px] mx-auto intersect:animate-in slide-in-from-bottom intersect-once duration-1250">
                <h1 className="text-4xl md:text-7xl leading-none font-bold">Stella tv</h1><h2 className="mt-5">
                <a className="text-[33px] leading-[44px] font-bold no-underline" href="#planes">
                    Comprar Stella TV Online
                </a>
            </h2>
                <div className="mt-5 text-white">Aquí tienes los <em>mejores planes con precios económicos, ofertas, promociones,
                    descuentos</em> y más. Aquí puedes tener canales en vivo, películas, serines y mucho deporte al
                    Comprar StellaTV Oficial o ser un <a href="https://stellatvvip.com/" className="hover:text-[#eeb500] no-underline">reseller
                        Oficial</a>
                    <div className="mt-7 md:w-1/2 mx-auto">
                        <div className="grid md:grid-cols-2 gap-2.5">
                            <a className="btn-outline no-underline text-white hover:text-[#eeb500]" href="#planes">
                            VER PLANES</a>
                            <HashLink to="/renovar#inicio" className="btn-primary no-underline">
                            RENOVAR
                            </HashLink>
                        </div>
                        <HashLink to="/reseller/#inicio"   className="mt-5 btn-primary no-underline" >
                            SER REVENDEDOR</HashLink></div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
